<template>
    <autocomplete item-value="id" :items="items" :loading="loading" :value="value" v-bind="$attrs" v-on="$listeners">
        <template v-slot:item="{ item }">
            <div class="d-flex flex-column" style="width: 100%">
                <span style="width: 70%">{{ item.ragione_sociale }}</span>
                <span class="text--secondary align-self-end">{{ item.cuaa }}</span>
            </div>
        </template>

        <template v-slot:selection="{ item }">
            <span>{{ item.ragione_sociale }} ({{ item.cuaa }})</span>
        </template>
    </autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AgricoltoriSelect',
    props: {
        value: { required: false }
    },
    created () {
        this.$store.dispatch('loadAgricoltori').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    computed: {
        ...mapState({
            items: state => state.global.agricoltori,
            loading: state => state.global.loading.agricoltori
        })
    }
}
</script>
